/**
 * Utilidades del árbol, separadas del componente.
 *
 * Un archivo que exporta componentes y funciones a la vez rompe el refresco en
 * caliente de Vite, por la misma razón que `period.ts`, `tones.ts` y
 * `closingContext.ts` viven aparte.
 */

import type { TreeNode } from "../api/types";

/** Solo los nodos cuyos ancestros están todos desplegados. */
export function visibleNodes(nodes: TreeNode[], expanded: Set<string>): TreeNode[] {
  const oculto = new Set<string>();
  return nodes.filter((node) => {
    if (node.parent_id && oculto.has(node.parent_id)) {
      oculto.add(node.node_id);
      return false;
    }
    if (node.has_children && !expanded.has(node.node_id)) oculto.add(node.node_id);
    return true;
  });
}

/**
 * Los identificadores que hay que desplegar para llegar hasta las cuentas.
 *
 * Nunca incluye apuntes: no son nodos del árbol. Por eso el botón dice
 * «Expandir a cuentas» y no «Expandir todo».
 */
export function expandToAccounts(nodes: TreeNode[]): Set<string> {
  return new Set(nodes.filter((node) => node.has_children).map((node) => node.node_id));
}
